/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  createDefaultGridModel,
  rendererIconByName,
  ROW_WARNING_CLASS,
  truthyCellRenderer,
} from '@gh/common-internal-shared';
import { DateTimeTypes } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { GridModel, ManualGridDefinitionWithModel } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';
import { getLeadSalesFolderMeetingId, LeadSalesFolderMeeting } from '../../../resources/lead.model';
import { isNil } from 'lodash';
import { currentDate, UTCToLocal } from '@gh/core-util';

@Injectable()
export class SfMeetingGridDefinition extends ManualGridDefinitionWithModel {
  currentDate: Date;
  constructor(private translationService: TranslationService) {
    super();
    this.currentDate = currentDate();
  }

  buildGridModel(): GridModel {
    return createDefaultGridModel({
      getId: getLeadSalesFolderMeetingId,
    });
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'startDate',
      headerName: this.translationService.get('lbl_date_and_time'),
      width: 170,
      valueFormatter: (params: any) => params.data.allDay
        ? isNil(params.data.startDate) ? ' ' : DateTimeTypes.ShortDate.format(UTCToLocal(params.data.startDate))
        : isNil(params.data.startDate) ? ' ' : DateTimeTypes.DateTime.format(UTCToLocal(params.data.startDate)),
    }, {
      field: 'subject',
      headerName: this.translationService.get('lbl_subject'),
      width: 170,
    }, {
      field: 'activityType',
      headerName: this.translationService.get('lbl_activity_type'),
      width: 130,
    }, {
      field: 'isDone',
      headerName: this.translationService.get('lbl_done'),
      width: 80,
      cellRenderer: truthyCellRenderer(rendererIconByName('done')),
    }, {
      field: 'location',
      headerName: this.translationService.get('lbl_location'),
      width: 170,
    }, {
      field: 'description',
      headerName: this.translationService.get('lbl_description'),
      width: 170,
    }, {
      field: 'notes',
      headerName: this.translationService.get('lbl_notes'),
      width: 170,
    }, {
      field: 'assignee',
      headerName: this.translationService.get('lbl_assigned_to'),
      width: 170,
      valueGetter: (param) => param.data.assignee ? param.data.assignee.contactName : '',
    }];
  }
  buildGridOptions(): GridOptions {
    return {
      rowClassRules: {
        [ROW_WARNING_CLASS]: ({ data }: { data: LeadSalesFolderMeeting }) =>
          !data.isDone && data.active && data.startDate < this.currentDate,
      },
    };
  }
}
